<script lang="ts">
	import AppScreen from './AppScreen.svelte'
	import StickyHeader from '../display/StickyHeader.svelte'
	import { Motion } from 'svelte-motion'
	import PanelHeader from '$src/lib/components/itineraries/PanelHeader.svelte'
	import Organizer from '$lib/components/itineraries/Organizer.svelte'
	import { toAmount } from '$src/lib/utils/currency'
	import Amount from '$src/lib/components/display/Amount.svelte'
	import ImmutableTitle from '$src/lib/components/itineraries/ImmutableTitle.svelte'
	import PanelBody from '$src/lib/components/itineraries/PanelBody.svelte'
	import BlockTemplateStatic from './BlockTemplateStatic.svelte'
	interface Props {
		[key: string]: any
	}

	let { ...props }: Props = $props()

	const highlightBlocks = [
		'/visuals/stock/tulum-1-unsplash.webp',
		'/visuals/stock/tulum-2-unsplash.webp',
	]

	let computedSrc = '/visuals/stock/creator.webp'
</script>

<AppScreen>
	<Motion {...props}>
		{#snippet children({ motion })}
			<div
				class="absolute bottom-0 w-full left-0 right-0 bg-brand-gray-5 h-2/3 rounded-t-xl z-20"
				use:motion
			>
				<PanelHeader
					class="rounded-t-xl bg-brand-gray-6 dark:bg-brand-gray-6 dark:lg:bg-brand-gray-6"
				>
					<div class="flex flex-col w-full">
						<div class="flex items-center justify-between w-full">
							<Organizer
								isStatic={true}
								imageUrl={computedSrc}
								name={'Sarah Smith'}
								isPublic={true}
								size="xs"
							/>

							<button
								class="bg-black text-white dark:bg-brand-primary/80 dark:text-white hover:dark:bg-brand-primary font-semibold transition-all px-4 text-sm py-2 rounded-md flex-shrink-0"
								onclick={null}
								>Buy <Amount rounded={true} amount={toAmount(2900)} />
							</button>
						</div>

						<ImmutableTitle title={'Tulum for Solo Females'} class="mt-4 lg:mt-7 pb-[6px]" />
					</div>
				</PanelHeader>

				<PanelBody>
					<div class="px-4 mt-2 w-full">
						<p class="text-xs text-brand-gray-4 mt-3">Trip Highlights</p>
						<div class="flex items-center my-2 space-x-2">
							<div class="relative group flex items-center space-x-2">
								{#each highlightBlocks as block}
									<div class="relative transition-opacity duration-300 cursor-pointer">
										<img
											class="h-36 w-36 rounded-md object-cover border-2 border-brand-gray-3 hover:border-brand-gray-2"
											src={block}
											alt="highlight"
										/>
									</div>
								{/each}

								<div
									class="absolute cursor-pointer w-12 z-10 hidden group-hover:flex items-center justify-center top-0 bottom-0 -left-6 h-full"
								>
									<div
										class="flex z-10 items-center shadow-lg justify-center w-8 h-8 bg-white rounded-full opacity-100"
									>
										<img
											src={`/visuals/icons/left-arrow-carousel.svg`}
											width={6}
											height={12}
											class="-ml-[2px]"
											alt="left arrow"
											aria-label="left arrow"
										/>
									</div>
								</div>
								<div
									class="absolute cursor-pointer w-12 z-10 hidden group-hover:flex items-center justify-center top-0 bottom-0 -right-4 h-full"
								>
									<div
										class="flex z-10 items-center shadow-lg justify-center w-8 h-8 bg-white rounded-full opacity-100"
									>
										<img
											src={`/visuals/icons/right-arrow-carousel.svg`}
											width={6}
											height={12}
											class="-mr-[2px]"
											alt="right arrow"
											aria-label="right arrow"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<ul class="px-4 flex flex-col space-y-6">
						<li class="w-full">
							<StickyHeader class="top-24 lg:top-32 w-full" onclick={null} title="Tulum Town" />
							<div class="flex flex-col mt-2">
								<BlockTemplateStatic
									title={'Nomad House on the Beach'}
									description={'Great for sunset coconuts and beach vibes'}
									blockId={null}
									isPublic={false}
									size="large"
									iconUrl={'/visuals/icons/custom/white/champagne-bottle-glass.svg'}
									bgColor={'bg-green-600'}
								/>
								<BlockTemplateStatic
									title={'La Velenta'}
									description={'Best area to stay'}
									blockId={null}
									isPublic={false}
									size="large"
									iconUrl={'/visuals/icons/select-all.svg'}
									bgColor={'bg-orange-600'}
								/>
							</div>
						</li>
					</ul>
				</PanelBody>
			</div>
		{/snippet}
	</Motion>
</AppScreen>
